import { render, staticRenderFns } from "./pictures.vue?vue&type=template&id=1071371a&scoped=true"
import script from "./pictures.vue?vue&type=script&lang=js"
export * from "./pictures.vue?vue&type=script&lang=js"
import style0 from "./pictures.vue?vue&type=style&index=0&id=1071371a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1071371a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1071371a')) {
      api.createRecord('1071371a', component.options)
    } else {
      api.reload('1071371a', component.options)
    }
    module.hot.accept("./pictures.vue?vue&type=template&id=1071371a&scoped=true", function () {
      api.rerender('1071371a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appSet/components/pictures.vue"
export default component.exports